import type { ResponseMode, StageGeometry, TaskKind, TrialSpec } from './types';

/**
 * 과제 모듈 계약. 엔진은 이 인터페이스만 안다.
 * 점 탐침이 첫 구현이고, Talking Heads / CBM-I / AAT 는 같은 자리에 꽂힌다.
 */
export interface TaskModule<Config, Stimuli, Meta> {
  readonly kind: TaskKind;
  readonly responseMode: ResponseMode;
  /** 에셋 캐시가 미리 렌더해야 할 자극 목록 */
  collectAssets(stimuli: Stimuli): readonly { id: string; text?: string; imageUrl?: string }[];
  generate(config: Config, stimuli: Stimuli, seed: number, geometry: StageGeometry): TrialSpec<Meta>[];
}

const registry = new Map<TaskKind, TaskModule<unknown, unknown, unknown>>();

export function registerTask<C, S, M>(mod: TaskModule<C, S, M>): void {
  registry.set(mod.kind, mod as TaskModule<unknown, unknown, unknown>);
}

export function getTask(kind: TaskKind): TaskModule<unknown, unknown, unknown> {
  const m = registry.get(kind);
  if (!m) throw new Error(`등록되지 않은 과제: ${kind}`);
  return m;
}
